module.exports = __webpack_public_path__ + "static/work04_03-e54679060e1bd1a8b851ce3838badb58.png";